import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface ShState {
    token: string;
    email: string;
    jwt_token: string;
    refresh_token: string;
    facebookUser: any;
    isLoggedInFacebook: boolean;
    googleUser: any;
    isLoggedInGoogle: boolean;
    setToken: (token: string) => void;
    setEmail: (email: string) => void;
    setJwtToken: (jwt_token: string) => void;
    setRefreshToken: (refresh_token: string) => void;
    setFacebookUser: (user: any) => void;
    setIsLoggedInFacebook: (isLoggedIn: boolean) => void;
    setGoogleUser: (user: any) => void;
    setIsLoggedInGoogle: (isLoggedIn: boolean) => void;
    restoreToInitialState: () => void;
}


const useStore = create<ShState>()(
  persist(
    (set) => ({
      email: '',
      token: '',
      jwt_token: '',
      refresh_token: '',
      facebookUser: null,
      isLoggedInFacebook: false,
      googleUser: null,
      isLoggedInGoogle: false,
      setToken: (token) => set(() => ({ token: token })),
      setEmail: (email) => set(() => ({ email: email })),
      setJwtToken: (jwt_token) => set(() => ({ jwt_token: jwt_token })),
      setRefreshToken: (refresh_token) => set(() => ({ refresh_token: refresh_token })),
      setFacebookUser: (user) => set(() => ({ facebookUser: user })),
      setIsLoggedInFacebook: (isLoggedIn) => set(() => ({ isLoggedInFacebook: isLoggedIn })),
      setGoogleUser: (user) => set(() => ({ googleUser: user })),
      setIsLoggedInGoogle: (isLoggedIn) => set(() => ({ isLoggedInGoogle: isLoggedIn })),
      restoreToInitialState: () => {
        // Rimuovi il jwt_token dal localStorage per l'API v2
        const storedData = localStorage.getItem('shu');
        if (storedData) {
          try {
            const parsedData = JSON.parse(storedData);
            if (parsedData?.state) {
              parsedData.state.jwt_token = "";
              parsedData.state.refresh_token = "";
              localStorage.setItem('shu', JSON.stringify(parsedData));
            }
          } catch (error) {
            console.error('Error updating localStorage during logout:', error);
          }
        }
        
        set(() => ({ 
          token: "", 
          email: "", 
          jwt_token: "",
          refresh_token: "",
          facebookUser: null, 
          isLoggedInFacebook: false,
          googleUser: null,
          isLoggedInGoogle: false
        }));
      },
    }),
    {
      name: 'shu', // name of item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // Using localStorage for JWT tokens
      partialize: (state) => ({ 
        token: state.token, 
        email: state.email, 
        jwt_token: state.jwt_token,
        refresh_token: state.refresh_token,
        facebookUser: state.facebookUser, 
        isLoggedInFacebook: state.isLoggedInFacebook,
        googleUser: state.googleUser,
        isLoggedInGoogle: state.isLoggedInGoogle
      }),
    },
  ),
);

export default useStore;

